import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';
import { i18n, init as i18nInit } from 'src/i18n';

// Create browser history to use in the Redux store
// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
// const history = createBrowserHistory({ basename: baseUrl });

// // Get the application-wide store instance, prepopulating with state from the server where available.
// const store = configureStore(history);
(async function () {
    await i18nInit();
    document.title = i18n("app.title");
    ReactDOM.render(
        // <Provider store={store}>
        //     <ConnectedRouter history={history}>
                <App />
        //     </ConnectedRouter>
        // </Provider>
        ,
        document.getElementById('root'));
    
    //registerServiceWorker();
    unregister();
  })();

